import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { DiseaseModel } from '../../../models/consultation-process/disease.model';
import { ConsultationUrl } from '../../../shared/urls/consultation.url';
import { Utility } from '../../../common/utility';
@Injectable()
export class SelectDiseaseService {
  constructor(public baseService: BaseService) {

  }

  getDiseaseList(id) {
    const url = ConsultationUrl.GET_CONSULTATION_COUNTRY_DISEASE.replace("{consultationId}", id);
    return this.baseService.getData(url);
  }

  getAddDiseaseData(consultationId) {
    const url = Utility.stringFormat(ConsultationUrl.GET_REMAIN_CONSULTATION_DISEASE, [consultationId]);
    return this.baseService.getData(url);
  }

  getAddRecommendDiseaseData(id) {
    const url = ConsultationUrl.GET_REMAIN_RECOMMEND_DISEASE.replace('{groupConsultationId}', id);
    return this.baseService.getData(url);
  }

  addDisease(consultationId, diseaseIds) {
    const url = Utility.stringFormat(ConsultationUrl.UPDATE_CONSULTATION_DISEASE, [consultationId]);
    return this.baseService.postData(url, diseaseIds);
  }

  updateDisease(consultationId, data, isMoveNextStep){
    let url = Utility.stringFormat(ConsultationUrl.UPDATE_CONSULTATION_DISEASE, [consultationId]);
    url += '?isMoveNextStep='+ isMoveNextStep;
    return this.baseService.update(url, data);
  }

  removeDisease(consultationId, id) {
    const url = Utility.stringFormat(ConsultationUrl.REMOVE_CONSULTATION_DISEASE, [consultationId, id]);
    return this.baseService.delete(url);
  }

  checkConsultationGroup(consultationId){
    const url = Utility.stringFormat(ConsultationUrl.CHECK_CONSULTATION_GROUP, [consultationId]);
    return this.baseService.getData(url);
  }
}

const diseases: Array<any> = [
  {
    'id': 1,
    'name': 'disease 1'
  },
  {
    'id': 2,
    'name': 'disease 2'
  },
  {
    'id': 3,
    'name': 'disease 3'
  },
  {
    'id': 4,
    'name': 'disease 4'
  },
  {
    'id': 5,
    'name': 'disease 5'
  },
  {
    'id': 6,
    'name': 'disease 6'
  },
  {
    'id': 7,
    'name': 'disease 7'
  },
  {
    'id': 8,
    'name': 'disease 8'
  },
  {
    'id': 9,
    'name': 'disease 9'
  }
];

const dataList: Array<DiseaseModel> = [
  {
    id: '1',
    name: 'abc',
    expiredDate: 1413173580,
    isVaccineCovered: false,
    isCovered: false,
    isAccept: false,
    isDecideAgainst: false,
    isGroupRecommendation: true

  },
  {
    id: '2',
    name: 'abc',
    expiredDate: 1413173580,
    isVaccineCovered: false,
    isCovered: true,
    isAccept: false,
    isDecideAgainst: false,
    isGroupRecommendation: false
  },
  {
    id: '3',
    name: 'abc',
    expiredDate: 1413173580,
    isVaccineCovered: false,
    isCovered: false,
    isAccept: false,
    isDecideAgainst: false,
    isGroupRecommendation: false
  },
  {
    id: '4',
    name: 'abc',
    expiredDate: 1413173580,
    isVaccineCovered: false,
    isCovered: false,
    isAccept: false,
    isDecideAgainst: false,
    isGroupRecommendation: false
  }
];



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/select-disease/select-disease.service.ts